import React, { useState } from 'react';
import Layout from '../components/Layout';
import BusinessInformationTab from './tabs/BusinessInformationTab';
import BrandingTab from './tabs/BrandingTab';
import LocationTab from './tabs/LocationTab';
import WharehouseManagementTab from './tabs/WharehouseManagementTab';
import ProductsTab from './tabs/ProductsTab';
import DeliveryServices from './tabs/DeliveryServices';
import TicketsTab from './tabs/TicketsTab';
import WeightGroupsTab from './tabs/WeightGroupsTab';
import Carriers from './tabs/Carriers';
import StatusTab from './tabs/StatusTab';
import PackageTypeTab from './tabs/PackageTypeTab';
import ShipmentMethodTab from './tabs/ShipmentMethodTab';

const Settings = () => {
  const [activeTab, setActiveTab] = useState('businessInformation');

  const items = [
    { tab: 'businessInformation', tabName: 'Business Information', tabPage: <BusinessInformationTab /> },
    { tab: 'branding', tabName: 'Branding', tabPage: <BrandingTab /> },
    { tab: 'location', tabName: 'Location', tabPage: <LocationTab /> },
    { tab: 'status', tabName: 'Status', tabPage: <StatusTab /> },
    { tab: 'wharehouseManagement', tabName: 'Wharehouse Management', tabPage: <WharehouseManagementTab /> },
    { tab: 'products', tabName: 'Products', tabPage: <ProductsTab /> },
    { tab: 'deliveryServices', tabName: 'Delivery Services', tabPage: <DeliveryServices /> },
    { tab: 'tickets', tabName: 'Tickets', tabPage: <TicketsTab /> },
    { tab: 'package-type', tabName: 'Package Type', tabPage: <PackageTypeTab /> },
    { tab: 'shipment-method', tabName: 'Shipment Method', tabPage: <ShipmentMethodTab /> },
    { tab: 'wieghtGroups', tabName: 'Weight Groups', tabPage: <WeightGroupsTab /> },
    { tab: 'carriers', tabName: 'Carriers', tabPage: <Carriers /> },
  ];

  const activeTabContent = items.find(item => item.tab === activeTab)?.tabPage;

  return (
    <Layout>
      <main className="p-4 bg-base-100 shadow-xl w-full h-full overflow-hidden">
        <h2 className="text-3xl font-semibold mb-4">Settings</h2>
        <div className="grid grid-cols-1 lg:grid-cols-5 gap-4 h-full">
          <aside className="lg:col-span-1 bg-base-200 rounded-lg overflow-y-auto max-h-[80vh]">
            <ul className="menu p-2 w-full gap-2">
              {items.map(({ tab, tabName }) => (
                <li key={tab}>
                  <a
                    onClick={() => setActiveTab(tab)}
                    className={`cursor-pointer ${activeTab === tab ? 'active text-blue-800 font-semibold' : ''}`}
                  >
                    {tabName}
                  </a>
                </li>
              ))}
            </ul>
          </aside>
          <section className="lg:col-span-4 overflow-auto max-h-[80vh] bg-white rounded-lg p-4 shadow-md">
            {activeTabContent}
          </section>
        </div>
      </main>
    </Layout>
  );
};

export default Settings;
